var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHexagoneThermoReady(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 242.941,
    height: 242.941,
    viewBox: "0 0 242.941 242.941",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 242.941,
    height: 242.941,
    rx: 55.382,
    ry: 55.382,
    fill: "#ffbd59"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M121.43,41.184c-13.656,0-24.851,11.194-24.851,24.851v68.795c-8.079,7.003-13.381,17.184-13.381,28.696,0,21.046,17.186,38.232,38.232,38.232s38.232-17.186,38.232-38.232c0-11.512-5.302-21.693-13.381-28.696v-13.359h7.646c3.167.045,5.771-2.486,5.816-5.654.045-3.167-2.486-5.771-5.654-5.816-.054,0-.108,0-.162,0h-7.646v-7.646h7.646c3.167.045,5.771-2.486,5.816-5.654.045-3.167-2.486-5.771-5.654-5.816-.054,0-.108,0-.162,0h-7.646v-7.646h7.646c3.167.045,5.771-2.486,5.816-5.654s-2.486-5.771-5.654-5.816c-.054,0-.108,0-.162,0h-7.646v-5.735c0-13.656-11.194-24.851-24.851-24.851ZM121.43,52.654c7.455,0,13.381,5.926,13.381,13.381v10.529c-.101.616-.101,1.244,0,1.859v17.257c-.101.616-.101,1.244,0,1.859v17.257c-.101.616-.101,1.244,0,1.859v20.632c0,1.83.874,3.55,2.352,4.63,6.685,4.879,11.029,12.689,11.029,21.61,0,14.846-11.916,26.762-26.762,26.762s-26.762-11.916-26.762-26.762c0-8.921,4.344-16.73,11.029-21.61,1.478-1.08,2.352-2.8,2.352-4.63v-71.251c0-7.455,5.926-13.381,13.381-13.381ZM121.34,90.803c-3.164.049-5.691,2.653-5.645,5.817v48.671c-10.071,3.168-15.666,13.901-12.498,23.971,2.505,7.962,9.886,13.378,18.233,13.379,10.557-.04,19.083-8.631,19.043-19.188-.031-8.294-5.407-15.621-13.309-18.14v-48.693c.045-3.167-2.485-5.772-5.652-5.817-.057,0-.115,0-.172,0Z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHexagoneThermoReady);
export default __webpack_public_path__ + "static/media/hexagone-thermo-ready.81ec9f9d18e41b76030800f40ea2ad9d.svg";
export { ForwardRef as ReactComponent };